import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Image } from '@deal/components'
import { CategoryType, HeroCuratedExpertFragment } from '#src/generated/graphql'
import EmptyCurations from '../EmptyCurations'
import RightProgress from '../RightProgress'
import { SellableWithImage, CategoryItemsBadge } from '..'
import styles from './styles.css'

interface Props {
  categories: CategoryItemsBadge[]
  itemsSellables: SellableWithImage[]
  onSubmit: () => void
  messageCount: number
  itemCount: number
  banner?: string | null
  expert: HeroCuratedExpertFragment
  recommendationsLink?: string
  conversationId: string
  type?: CategoryType | null
}

const StatusBar: React.SFC<Props> = ({
  categories,
  itemsSellables,
  expert,
  onSubmit,
  messageCount,
  itemCount,
  banner,
  recommendationsLink,
  conversationId,
  type
}) => (
  <RightProgress
    messageCount={messageCount}
    itemCount={itemCount}
    banner={banner}
    expertFirstName={expert.firstName}
    isPlaceholderExpert={expert.expertAttributes && expert.expertAttributes.placeholderExpert}
  >
    {!itemsSellables.length || !recommendationsLink ? (
      <EmptyCurations
        onSubmit={onSubmit}
        type={type}
        conversationId={conversationId}
        expertFirstName={expert.firstName}
        isPlaceholderExpert={expert.expertAttributes && expert.expertAttributes.placeholderExpert}
      />
    ) : (
      <>
        <div className={styles.smallTitle}>fresh from your expert</div>
        <div className={styles.title}>{expert.firstName}'s custom curation</div>
        <div className={styles.itemsContainer}>
          <div className={styles.itemsSubContainer}>
            {categories.map(({ categoryName, itemsNumber }) => (
              <div key={categoryName} className={styles.recommendationCategory}>
                {itemsNumber} {categoryName} {itemsNumber === 1 ? 'option' : 'options'}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.footer}>
          <Link to={recommendationsLink} className={styles.link}>
            <Button onClick={onSubmit} className={styles.button}>
              View recommendations
            </Button>
          </Link>
          <div className={styles.curatedContainer}>
            {expert.expertProfile &&
              expert.expertProfile.profilePhoto && (
                <Image
                  src={expert.expertProfile.profilePhoto.url}
                  className={styles.curatedImage}
                  htmlAttributes={{
                    alt: `${expert.firstName} ${expert.lastName} on Curated.com`
                  }}
                />
              )}
            <div className={styles.curatedText}>
              Curated by <strong>{`${expert.firstName} ${expert.lastName}`}</strong> for you
            </div>
          </div>
        </div>
      </>
    )}
  </RightProgress>
)

export default StatusBar
